import { render, staticRenderFns } from "./addNode.vue?vue&type=template&id=81d8d9ac&scoped=true&"
import script from "./addNode.vue?vue&type=script&lang=js&"
export * from "./addNode.vue?vue&type=script&lang=js&"
import style0 from "./addNode.vue?vue&type=style&index=0&id=81d8d9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d8d9ac",
  null
  
)

export default component.exports